import { IsNotEmpty, Length } from 'class-validator';
import { createFromValidationResolver } from '@cp/utils/form/resolver';
import { CARD_EXPIRATION_LENGTH } from '@cp/ds/src/components/form/components/field/cardExpiration';
import { CVC_LENGTH } from '@cp/ds/src/components/form/components/field/cvc';
import { CARD_NUMBER_LENGTH } from '@cp/ds/src/components/form/components/field/cardNumber';

export class PaymentCardModel {
  @IsNotEmpty()
  @Length(CARD_NUMBER_LENGTH)
  cardNumber: string;

  @IsNotEmpty()
  @Length(CARD_EXPIRATION_LENGTH)
  expDate: string;

  @IsNotEmpty()
  @Length(CVC_LENGTH)
  cvv: string;
}

export const paymentCardValidationResolver = createFromValidationResolver(PaymentCardModel);
